import { render, staticRenderFns } from "./BloqueMapCir.vue?vue&type=template&id=2afc5aae"
import script from "./BloqueMapCir.vue?vue&type=script&lang=js"
export * from "./BloqueMapCir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports